// Shared constants + small helpers used across the Car and Bike fleet
// pages, kept in one place so both stay in lockstep with the backend's
// CarValidation.js / BikeValidation.js enums instead of drifting apart.

export const FUEL_TYPES = ["Petrol", "Diesel", "Bio-Diesel", "CNG", "LPG", "EV"];

export const FEATURES = [
    "Luggage", "Mobile Charger", "Baby Seat", "Puncture Kit", "Air Freshener", "Voice Control",
    "Reverse Camera", "Reverse Sensor", "Bluetooth", "AC", "Music System", "Power Steering",
    "Power Window", "Spare Tyre", "Air Bag", "Boot Space",
];

export const TRANSMISSION_TYPES = ["Manual", "Automatic"];

// Matches CarValidation.js/BikeValidation.js's DOCUMENT_NAMES exactly - a
// vehicle can hold at most one of each, re-uploading a name replaces it.
export const DOCUMENT_NAMES = ["RC", "PUC", "INSURANCE", "OTHER"];

export const VERIFICATION_STATUSES = ["pending", "verified", "rejected"];

// The 20/50/70/100 checkpoints carDetail/bikeDetail compute server-side
// (registered -> images -> device -> priced & verified), mirrored here only
// as display copy for the progress bar - the number itself always comes
// from the API response, never recomputed client-side.
export const verificationStageLabel = (stage) => {
    if (stage >= 100) return "Ready to rent";
    if (stage >= 70) return "Device registered - pending pricing/verification";
    if (stage >= 50) return "Images uploaded - pending device registration";
    return "Registered - pending images";
};

export const formatPreviousValue = (value) => {
    if (value === undefined) return null;
    if (value === null || value === "") return "empty";
    if (typeof value === "object") return JSON.stringify(value);
    return String(value);
};

// Mirrors ServiceValidation.js's enums exactly.
export const SERVICE_TYPES = ["PMS", "Bodyshop", "Partchange"];
export const SERVICE_ACTIONS = ["Repair", "Replace", "Inspect"];
export const SERVICE_CENTER_TYPES = ["OWN", "Tie-up", "Authorized"];
export const PAYMENT_MODES = ["CASH", "UPI", "CARD"];
export const SERVICE_STATUSES = ["Initiated", "Started", "Closed"];

export const serviceStatusVariant = (status) => {
    if (status === "Closed") return "text-bg-success";
    if (status === "Started") return "text-bg-warning";
    return "text-bg-secondary";
};

// For <input type="datetime-local"> - servicedStartAt/servicedEndAt are
// full timestamps (ISO8601), not plain dates, so this keeps the local
// wall-clock time the value already represents rather than shifting it
// through toISOString()'s UTC conversion.
export const toDateTimeInputValue = (value) => {
    if (!value) return "";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "";
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
